import { Box, Typography, useTheme, Button, Modal, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import AuthGuard from "../../components/AuthGuard";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import Form from "./form";
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import Tooltip from '@mui/material/Tooltip';
import swal from "sweetalert";
import { jwtDecode } from "jwt-decode";

const Accounts = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [accountData,setAccountData] = useState([])
  const [cookies,setCookie] = useCookies(['token'])
  const [showModal,setShowModal] = useState(false)
  const decoded = jwtDecode(cookies["token"])
  const jsonData = JSON.parse(decoded.userInfo)

  const fetchAccounts = async()=>{

    const data = await fetch(process.env.REACT_APP_BACKEND_URL+"/account/all",{headers:{
      Authorization:"Bearer "+cookies['token']
    }})
    if(data.status!==200){
      setCookie("token",null)
      return
    }
    const json = await data.json()
    setAccountData(()=>{

      return json.filter(acc=>jsonData.companies.id==1 || acc.company.id== jsonData.companies.id
).map((usr,ind)=>({...usr,name:usr.full_name,access:usr.role?usr.role.name:null,no:ind+1}))
    })
  }


  useEffect(()=>{
    fetchAccounts()
  },[])
  const toggleEnableStatus = async (accountId, currentStatus) => {
    let confirmationMessage;
    switch (currentStatus) {
        case true:
            confirmationMessage = "Are you sure you want to disable?";
            break;
        case false:
            confirmationMessage = "Are you sure you want to enable?";
            break;
        default:
            confirmationMessage = "Are you sure you want to switch status?";
    }
    const confirmed = window.confirm(confirmationMessage);    if (!confirmed) return;
  
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/account/${accountId}/toggleEnable`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + cookies['token']
        },
        body: JSON.stringify({ enable: !currentStatus }) 
      });
  
      const responseData = await response.json();
  
      if (response.ok) {
        swal("Success", responseData.message, "success");
        window.location.reload();
      } else {
        if (response.status === 401) {
          setCookie("token", null);
          swal("Failed", responseData.message, "error");
        } else if (response.status === 404) {
          swal("Failed", responseData.message, "error");

        } else {
          
          throw new Error(responseData.message);
          swal("Failed", responseData.message, "error");
        }
      }
    } catch (error) {
      console.error('Error toggling user enable status:', error);
      swal("Failed", "Error toggling user enable status. Please try again", "error");
    }
  }

  const columns = [
    { field: "no", headerName: "No" },
    {
      field: "company",
      headerName: "Company Name",
      flex: 1,
      renderCell: ({ row }) => {
        return (
            <Typography color={colors.black[500]} sx={{ ml: "5px" }}>
              {row.company.name}
            </Typography>
        );
      },
    },
    {
      field: "account_number",
      headerName: "Account Number",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "_enabled",
      headerName: "Status",
      flex: 1,
      renderCell: ({ row }) => {
        const iconColor = row._enabled ? "green":"red";
        const transactionType = row._enabled ? "Enabled" : "Disabled";
        const icon = { transactionType, style: { color: iconColor } };
        return (
          <Typography color={colors.black[500]} sx={{ ml: "5px" }}>
            <span style={{ color: iconColor }}>{icon.transactionType}</span>
          </Typography>
        );
      }
    },
    {
      field: "Action",
      headerName: "Action",
      flex: 1,
      renderCell: ({ row }) => {
        const iconColor = row._enabled ? "green":"red";
        const icon = row._enabled ?<Tooltip title="Enable Account" arrow>
        <ToggleOnIcon style={{ color: iconColor, fontSize: '40px' }} />
      </Tooltip>  : (
          <Tooltip title="Disable Account" arrow>
            <ToggleOffIcon style={{ color: iconColor, fontSize: '40px'}} />
          </Tooltip>
        );
        return (
          <Box>
              <IconButton onClick={() => toggleEnableStatus(row.id, row._enabled)}>
              <Typography color={colors.black[500]} sx={{ ml: "5px", mt:"10px"}}>
        {icon}
      </Typography>
            </IconButton>
          </Box>
        );
      },
    }
  ];
  if(jsonData.roles.name==='Company User'|| jsonData.roles.name==='Company Admin'){
    columns.pop();
  }
  const callBackAfterSubmit = ()=>{
    fetchAccounts()
    setShowModal(false)
  }

  return (
    <AuthGuard>
    <Box m="10px">
    <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} px={"1rem"}>
      <Header subtitle={"Manage Accounts"} />
      <Modal open={showModal} onClose={()=>setShowModal(false)}>
        <Form callBackAfterSubmit={callBackAfterSubmit} />
      </Modal>
      {(jsonData.roles.name==="Super Admin" || jsonData.roles.name==="Admin") &&
      <Button variant="contained" onClick={()=>setShowModal(true)} sx={{height:"2rem",width:"10rem",boxSizing:"border-box",background:"#1A8D90",color:"#fff"}}>
                Add Account
      </Button>
      }
      </Box>
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          '& .MuiDataGrid-row:nth-child(odd)': {
            border: "1px solid white",
            backgroundColor: theme.palette.mode === 'light' ? colors.white[300] : "#F3F5F8",
          },
          '& .MuiDataGrid-iconSeparator': {
            display: 'none',
          },
          "& .MuiDataGrid-root": {
            border: "1px solid white",
          },
          "& .MuiDataGrid-row": {
            border: "1px solid white",

          },
          "& .MuiDataGrid-cell": {
            fontSize: 15,
            color: colors.black[500],
            border: "none !important",

          },
          "& .name-column--cell": {
            fontWeight: "bold",
            color: colors.black[500],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.white[500],
            color: colors.black[900],
            fontSize: 20,
            border: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            whiteSpace: "normal",
            lineHeight: "normal",
            fontWeight: "bold",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[500],
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: colors.white[500],
            border: "none",

          },
          "& .MuiDataGrid-pagination": {
            "& .MuiTablePagination-menuItem": {
              color: "#000000",
            },
          },
          "& .MuiTablePagination-root": {
            color: "#000000",
          },
          "& .MuiSvgIcon-root ": {
            color: "#000000",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            left: "75%", /* Position the element at the center horizontally */
            transform: `translateX(-75%)`,
            color: `${colors.black[500]} !important`,
          },
          "& .MuiCheckbox-root": {
            color: `${colors.black[500]} !important`,
          },
            "& .MuiDataGrid-row:hover": {
            backgroundColor: "none",
            },
        }}
      >
        <DataGrid rows={accountData} columns={columns} />
      </Box>
    </Box>
    </AuthGuard>
  );
};

export default Accounts;
